import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoObjectTbmSensorModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoObjectTbmSensorModel._instance == null) GeoObjectTbmSensorModel._instance = new GeoObjectTbmSensorModel(authManager);
        return GeoObjectTbmSensorModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-object-tbm-sensors');

        this.entityName = 'model-sections.GeoObjectTbmSensor';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Tbm Face Pressure Sensor';
        this.setLabel = 'Tbm Face Pressure Sensors';

        this.browser = {
            name: 'default-model-sections-geoobjecttbmsensor-browser',
            moduleName: 'default-model-sections-geoobjecttbmsensor-browser',
            moduleTitle: 'Tbm Face Pressure Sensors',
            moduleStateSlotName: 'default-model-sections-geoobjecttbmsensor-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoobjecttbmsensor-editor',
            moduleName: 'default-model-sections-geoobjecttbmsensor-editor',
            moduleTitle: 'Tbm Face Pressure Sensor',
            moduleStateSlotName: 'default-model-sections-geoobjecttbmsensor-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'objectTbmId',
                type: 'GeoObjectTbm',
                persistent: true,
                label: 'Object Tbm',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'levelAboveTbmAxis',
                type: 'float',
                persistent: true,
                unit: 'm',
                label: 'Level Above Tbm Axis',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
